/**
 * Collapse dynamic route segments so per-page labels keep low cardinality.
 *
 * Shared by page-perf timing and session tracing so both agree on what counts
 * as "a page" — a label that fragments per id makes both useless.
 *
 * `question-sets` and `battle` have static sibling routes (…/create, …/friends,
 * …/leaderboard) that must stay distinct, so they use a negative lookahead.
 */
export function normalizePageLabel(pathname: string): string {
  return pathname
    .replace(/\/(question|session|subject|assignments|results|attempts|feedback|learning-moments|concept-lab)\/[^/]+/, '/$1/:id')
    .replace(/\/question-sets\/(?!create)[^/]+/, '/question-sets/:id')
    .replace(/\/battle\/(?!friends|leaderboard)[^/]+/, '/battle/:id')
    .replace(/\/plan\/day\/[^/]+/, '/plan/day/:date');
}

/**
 * Page label including a `?tab=` selector, for routes where the tab *is* the
 * page (`/plan`, `/settings`). Everything else ignores the query string.
 */
export function normalizePageLabelWithTab(pathname: string, search: string): string {
  const base = normalizePageLabel(pathname);
  const tab = new URLSearchParams(search).get('tab');
  return tab ? `${base}?tab=${tab.slice(0, 32)}` : base;
}
